import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PropertyList from "../components/PropertyList"

import "bootstrap/dist/css/bootstrap.min.css"

const PropertyListTemplate = ({
  pageContext: { properties, title, description, keywords },
}) => (
  <Layout property={properties[0]}>
    <SEO title={title} description={description} keywords={keywords} />
    <PropertyList properties={properties} />
  </Layout>
)

export default PropertyListTemplate
